import {
    useSelector
} from 'react-redux';
import { post, get } from '../Services/http';
import { storeIdConverter } from '../Services/StoreId.service';
import {catchError} from "./Error.action";

export const USER_GEOLOCATION = 'USER_GEOLOCATION';
export const SET_DAY = 'SET_DAY';
export const SET_STORES = 'SET_STORES';
export const SET_STORES_OPENINGS_DATES = 'SET_STORES_OPENINGS_DATES';
export const INIT_STORES = 'INIT_STORES';
export const SET_INDEX = 'SET_INDEX';
export const SET_FILTER_STRING = 'SET_FILTER_STRING';
export const SET_FILTER_STORE = 'SET_FILTER_STORE';
export const BOOKING_ERROR = 'BOOKING_ERROR';

export const setCoords = (coords) => ({
    type: USER_GEOLOCATION,
    payload: { coords }
})

export const setStores = (stores) => ({
    type: SET_STORES,
    payload: { stores }
})
export const setFilterStore = (filteredStores) => ({
    type: SET_FILTER_STORE,
    payload: { filteredStores }
});
export const initStores = (stores) => (dispatch) => {
    dispatch(setStores(stores));
    dispatch(setFilterStore(stores));
}


export const setIndex = (index) => ({
    type: SET_INDEX,
    payload: { index }
})

export const setFilterString = (filterString) => ({
    type: SET_FILTER_STRING,
    payload: {
        filterString
    }
})

export const storeFilter = (filterString, stores, dispatch) => {    
    const filteredStores = stores.filter(({ storeAddress, storeName, storeCity, storePhone, storePostalCode, storeRegion }) => [
        storeAddress, storeName, storeCity, storePhone, storePostalCode, storeRegion
    ].join(' ').toLowerCase().includes(filterString.toLowerCase()));
    dispatch(setFilterStore(filteredStores));
    dispatch(setFilterString(filterString));
}

export const booking = (info) => post("/api/booking", info);

export const setIndexAndCoords = (index, stores, dispatch) => {
    dispatch(setIndex(index));
    const selectedStore = stores.find(s => s.index === index);
    dispatch(setCoords({
        lat: selectedStore.lat,
        lng: selectedStore.lng
    }));
}

export const getCurrentStore = () => {
    const { stores, index } = useSelector(state => state.booking);
    return stores.find(store => store.index === index);
}

export const setAvailableDates = (storeId, dispatch) => {
    get(`/api/stores/GetAvailableBookingDates?storeId=${storeIdConverter(storeId).withC}`)
    .then(response => response.json())
    .then(data => {
        const dates = data ? (data.map(({ date, closes, opens }) => ({ date: new Date(date.split("T")[0]), closes, opens }))) : null;
        if (dates != null) {
            dispatch({
                type: SET_STORES_OPENINGS_DATES,
                payload: { dates }
            })
        }
    }).catch(ex => {
        dispatch(catchError(ex, error => {
            return setError({
                modelState: error
            });
        }));
    });
}

export const setDay = (day) => ({
    type: SET_DAY,
    payload: { day }
})

export const setError = error => ({
    type: BOOKING_ERROR,
    payload: {
        error
    },
})